import { flow, types } from 'mobx-state-tree';
import { Tickets } from '../../http-requests';
import { ITicket } from '../../types';

const TicketModel = types.model({
  id: types.optional(types.string, ''),
});

//TODO: стор не готов, сделан пока исключительно для создания обращения (перевод заявки в обращение)

export const TicketsStore = types
  .model({
    list: types.optional(types.array(TicketModel), []),
  })
  .views((self) => ({
    //...
  }))
  .actions((self) => ({
    createTicket: flow(function* (data: ITicket) {
      const response = yield Tickets.CreateTicket(data);
    }),
  }));
